import { useQuery } from 'react-query';

import {
  ResultsByWarriorArgs,
  ResultsByWarriorResponse,
} from '~/../api/common.types';
import { api } from '~/client/api';

export const useGetResultsByWarrior = ({
  data,
  enabled,
}: {
  data: ResultsByWarriorArgs;
  enabled: boolean;
}) => {
  return useQuery<ResultsByWarriorResponse | undefined, Error>(
    ['get-results-by-warrior', data, data.warriorId],
    () => api.getResultsByWarrior(data),
    {
      enabled,
      staleTime: 60 * 1000 * 5,
    }
  );
};
